import { Observable, firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'projects/access-control/src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class AuthenticationService {
	constructor(private http: HttpClient) {}

	async validateToken(username: string): Promise<{ validate: boolean }> {
		return await firstValueFrom(
			this.http.get<{ validate: boolean }>(`${environment.apiUrl}/${username}`)
		);
	}
}
